import { getShortenedNumber } from '@eventbrite/eds-utils';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { RatingDisplay } from '@eventbrite/trust-signals-lib';
import React from 'react';
import { Organizer } from '../../types';

interface OrganizerTrustSignalsProps {
    followCount: number;
    totalEvents: number;
    organizer: Organizer;
}

interface SignalDisplayProps {
    count: number;
    title: GenericLazyString;
}

const SignalDisplay = ({ count, title }: SignalDisplayProps) => {
    return (
        <div className="signal-display__container">
            <span className="eds-text-bl eds-text-weight--bold">
                {getShortenedNumber(count)}
            </span>
            <p className="eds-text-bs eds-text-color--ui-600">{title}</p>
        </div>
    );
};

export const OrganizerTrustSignals = ({
    followCount,
    totalEvents,
    organizer,
}: OrganizerTrustSignalsProps) => {
    const signalsData = [
        { count: followCount, title: gettext('Followers') },
        { count: totalEvents, title: gettext('Total events') },
    ];

    return (
        <div className="organizer-trust-signals__container">
            <RatingDisplay
                organizerData={{
                    organizerName: organizer.name,
                    organizerId: organizer.id,
                }}
                size="medium"
                disableClick
            />
            {signalsData.map(({ count, title }, idx) => {
                if (!count) return null;
                return <SignalDisplay key={idx} count={count} title={title} />;
            })}
        </div>
    );
};
